import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: `${API_URL}/api`,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Handle auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const register = (data) => api.post('/auth/register', data);
export const getMe = () => api.get('/auth/me');
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const verifyResetToken = (token) => api.post('/auth/verify-reset-token', { token });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });

// Tickets
export const getTickets = (params) => api.get('/tickets', { params });
export const getTicket = (id) => api.get(`/tickets/${id}`);
export const createTicket = (data) => api.post('/tickets', data);
export const updateTicket = (id, data) => api.put(`/tickets/${id}`, data);
export const deleteTicket = (id) => api.delete(`/tickets/${id}`);
export const takeTicket = (id) => api.post(`/tickets/${id}/take`);
export const addComment = (id, contenuto, file = null) => {
    const formData = new FormData();
    formData.append('contenuto', contenuto);
    if (file) {
        formData.append('file', file);
    }
    return api.post(`/tickets/${id}/comments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
export const uploadAttachment = (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/tickets/${id}/attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

// Stats
export const getDashboardStats = () => api.get('/stats/dashboard');
export const getClientDashboardStats = () => api.get('/stats/client-dashboard');

// Categories
export const getCategories = () => api.get('/categories');
export const addCategory = (nome) => api.post('/categories', { nome });
export const updateCategory = (oldName, newName) => api.put(`/categories/${encodeURIComponent(oldName)}`, { nome: newName });
export const deleteCategory = (name) => api.delete(`/categories/${encodeURIComponent(name)}`);

// Users
export const getOperators = () => api.get('/users/operators');
export const getAllStaff = () => api.get('/users/staff');
export const getAllUsers = () => api.get('/users/all');
export const getUser = (id) => api.get(`/users/${id}`);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const resetUserPassword = (id, password, sendEmail = false) => 
    api.post(`/users/${id}/reset-password`, { password, send_email: sendEmail });
export const createOperator = (data) => api.post('/users/create-operator', data);
export const createStaffUser = (data) => api.post('/users/create-staff', data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const getAvailableStaff = () => api.get('/staff/available');

// Profile
export const getProfile = () => api.get('/profile');
export const updateProfile = (data) => api.put('/profile', data);
export const changePassword = (currentPassword, newPassword) => 
    api.post('/profile/change-password', { current_password: currentPassword, new_password: newPassword });

// Admin Settings
export const getAdminSettings = () => api.get('/admin/settings');
export const updateAdminSettings = (data) => api.put('/admin/settings', data);

// Departments (Reparti)
export const getDepartments = () => api.get('/departments');
export const getDepartment = (id) => api.get(`/departments/${id}`);
export const createDepartment = (data) => api.post('/departments', data);
export const updateDepartment = (id, data) => api.put(`/departments/${id}`, data);
export const deleteDepartment = (id) => api.delete(`/departments/${id}`);
export const addStaffToDepartment = (deptId, staffId) => api.post(`/departments/${deptId}/staff`, { staff_id: staffId });
export const removeStaffFromDepartment = (deptId, staffId) => api.delete(`/departments/${deptId}/staff/${staffId}`);

// Close ticket
export const closeTicket = (id, motivazione) => api.post(`/tickets/${id}/close`, { motivazione });

export default api;
